import {Flex,Grid,GridItem,Box,Select,InputGroup,Button,
  InputLeftElement,Input,Heading,Text,TableContainer,
  Checkbox,Table,Thead,Tbody,Th,Textarea,Tr,Td,} from '@chakra-ui/react';
  import styled from "@emotion/styled";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState,useEffect,useMemo } from 'react';
  import {useAtom,atom} from 'jotai'
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../../utils/apiCall';
  import {  openAtom, notificationAtom, openNAtom, modalAtom } from "../../../../context";
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';



const indexAtom = atom<number | null>(null);

  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
  `
export default function BatchInvite() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_n_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();
 const [Name,set_Name] = useState('');
 const [Venue,set_Venue] = useState('');
 const [InductionDate,set_Date] = useState('');
const [PaymentDeadlineDate,set_PaymentDeadlineDate] = useState('');


  const [,set_modal] = useAtom(modalAtom);
  const [is_check_all,set_is_check_all] = useState<any>(false);
  const [checked_ids,set_checked_ids] = useState<any>([]);

  const [selected_status,set_selected_status] = useState<null | string>(null);

 // "Select all" below needs the full matching list (not just one page) so an
 // admin can batch-invite every due student at once - so this does need to
 // fetch everything. The old code fetched one page at a time, waiting for
 // each response before requesting the next; this fetches a bigger page size
 // and batches requests 5-at-a-time instead of one sequential call per page.
 const { data: all_invite = [], isLoading } = useQuery(
  ["induction-due-all"],
  async () => {
    const fetchPageSize = 1000;
    const first = await apiCall().get(
      `/Exam/students/dueForInduction?PageNumber=1&PageSize=${fetchPageSize}`
    );
    let items = first.data?.reportItems || [];
    const totalPages = first.data?.PageCount || 1;

    if (totalPages > 1) {
      const remainingPages = [];
      for (let page = 2; page <= totalPages; page++) remainingPages.push(page);

      const batchSize = 5;
      for (let i = 0; i < remainingPages.length; i += batchSize) {
        const batch = remainingPages.slice(i, i + batchSize);
        const responses = await Promise.all(
          batch.map((page) =>
            apiCall().get(`/Exam/students/dueForInduction?PageNumber=${page}&PageSize=${fetchPageSize}`)
          )
        );
        responses.forEach((res) => {
          items = [...items, ...(res.data?.reportItems || [])];
        });
      }
    }

    return items;
  },
  { staleTime: 5 * 60 * 1000 }
);

  const [search, set_search] = useState('');
  const [debounced_search, set_debounced_search] = useState('');

  // Debounce the search box so typing doesn't refilter on every keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  const filter_data = useMemo(() => {
    let data = all_invite || [];
    if (selected_status) {
      data = data.filter((eData: any) => eData.Status?.toLowerCase() === selected_status.toLowerCase());
    }
    if (debounced_search) {
      const term = debounced_search.toLowerCase();
      data = data.filter((eData: any) => Object.values(eData).join(' ').toLowerCase().includes(term));
    }
    return data;
  }, [all_invite, selected_status, debounced_search]);

  const itemsPerPage = 10;
  const [pageNumber, set_pageNumber] = useState(1);

  useEffect(() => {
    set_pageNumber(1);
  }, [debounced_search, selected_status]);

  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, filter_data.length);
  const currentItems = filter_data.slice(itemOffset, endOffset);
  const pageCount = Math.max(1, Math.ceil(filter_data.length / itemsPerPage));

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };


   const {isLoading:approveIsLoading,mutate:multi_invitation} = useMutation({
     mutationKey:['induction-invite'],
     mutationFn: async(payload:any)=> {
     // console.log(checked_ids,'checked')
      return await apiCall().post(`/Exam/BatchExamInductionInvite`,payload)
    },
     onSuccess(data:any){
       //console.log(data,'data')
       set_notification({
         type:'success',
         message:data.data.Message || ' Induction Invite Sent Successfully'
       });
       set_n_open(true);
       queryClient.invalidateQueries(['induction-due-all']);
       queryClient.invalidateQueries(['induction-page']);
       queryClient.invalidateQueries(['induction-search-all']);
     },
     onError(error:any){
       set_notification({
         type:'error',
         message:error.data.Message || 'Error Occured'
       });
       set_n_open(true);
     },
     onSettled(){
       set_open(false);

     },
   })

   const handleMultipleInvites = () =>{
     if(Name && Venue && InductionDate && checked_ids && checked_ids.length > 0 ){
        multi_invitation({
          StudentNumbers:[
            ...checked_ids
          ],
          InductionName:Name,
          InductionDate,
          InductionVenue:Venue,
          PaymentDeadlineDate:PaymentDeadlineDate,

        });
     }
     else{
      set_notification({
        type:'error',
        message:'fill on all required field and select a Student'
      })
      set_n_open(true);
     }
   }
  


  const handleMultipleCheck=()=>{
    if(!is_check_all){
      let allStudents = filter_data && filter_data.length > 0 ? 
        filter_data.map((eStudent:any)=>eStudent.StudentNo):[];
      set_checked_ids(allStudents);
    }else{
      set_checked_ids([]);
    }
    set_is_check_all(!is_check_all);
  }

  const handleSingleCheck=(StudentNo:string) =>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    if(check){
      set_checked_ids((all_students:any) => all_students.filter((eStudent:string) => eStudent !== StudentNo))
    }else{
      set_checked_ids([...checked_ids,StudentNo])
    }

  }
  const handleCheck=(StudentNo:string)=>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    return check?true:false;
  }

  useEffect(() => {
    set_checked_ids([]);
  }, [selected_status]);

  return (
    <Grid minW="80dvw" p="20px" templateColumns="1fr">
      <GridItem as={Flex} gap="20px" align="center">
        <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          <InputLeftElement pointerEvents='none'>
            <SearchIcon color='gray.300' />
          </InputLeftElement>
          <Input value={search} onChange={(e: any) => set_search(e.target.value)} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}} onClick={() => set_search('')}><ReloadIcon /></span>
        </InputGroup>
        <Select w="120px" onChange={(e:any)=>set_selected_status(e.target.value)} placeholder='Status'>
          <option>Inducted</option>
          <option>Applied for induction</option>
          <option>Due for Induction</option>
          <option>Invited for induction</option>
        </Select>
      </GridItem>
      <GridItem as={Flex} flexDir="column" gap="20px">
        <Heading>Batch Invites</Heading>
        <Text>Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={{...HeadStyle,maxWidth:"50px"}}>
                  <label>
                    <Checkbox colorScheme={is_check_all?'green':'none'} isChecked={is_check_all} onChange={handleMultipleCheck} />
                  </label>
                </Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>IsInvited</Th>
                <Th sx={HeadStyle}>HasApplied</Th>
                <Th sx={HeadStyle}>IsOldStudent</Th>
                <Th sx={HeadStyle}>Ismoved</Th>
                {/* <Th sx={HeadStyle}>NewMembershipNo</Th> */}
                <Th sx={HeadStyle}>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.StudentNo}>
                <Td sx={{...DataStyle,maxWidth:"50px"}}>
                  <label>
                  <Checkbox colorScheme={handleCheck(eCandidate.StudentNo)?'green':'none'} isChecked={handleCheck(eCandidate.StudentNo)} onChange={()=>handleSingleCheck(eCandidate.StudentNo)} />
                  </label>
                </Td>
                <Td sx={DataStyle}>{eCandidate.FirstName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.LastName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsInvitedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.HasAppliedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsOldStudent?'Yes': 'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsMovedToMembership ?'Yes':'No'}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.FinalMembershipNo?'Yes':'No'}</Td> */}
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
              
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Pending Approvals'  
      }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
      </GridItem>
      <GridItem as={Flex} flexDir="column" gap="20px" >
        <Flex w="100%" flexDir="column" gap="10px">
          <strong>Induction Name</strong> 
          <Input value={Name} onChange={(e)=>set_Name(e.target.value)} placeholder='Induction Name'borderColor="green"
            type="text" />
          <strong>Induction Venue</strong> 
          <Input value={Venue} onChange={(e)=>set_Venue(e.target.value)} placeholder='Induction Venue' borderColor="green" type="text" />
          <strong>Induction Date</strong> 
          <Input value={InductionDate} onChange={(e)=>set_Date(e.target.value)} borderColor="green" type="datetime-local" />
          <strong>Payment Deadline Date</strong>
          <Input value={PaymentDeadlineDate} onChange={(e)=>set_PaymentDeadlineDate(e.target.value)} placeholder='Induction Venue' borderColor="green"  type="datetime-local" />
        </Flex>
        <Flex justify="center" gap="30px" align="center">
          <Button  bg="var(--dark-green-color)" onClick={checked_ids && checked_ids.length > 0?()=> handleMultipleInvites ():()=>{}}
           color="var(--white-color)" width="130px"  >
            {approveIsLoading?'Loading':'Send Invites'}
          </Button>
        </Flex> 
      </GridItem>
    </Grid>
    
  )
    
  }
  const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`